import { DefaultLMSPolicy, initLMS } from '@nsc/simple-lms/init.js';
import '@nsc/simple-lms/entities/index.js';
import '@nsc/simple-lms/api/index.js';
import '@nsc/smartteams-shared/api/index.js';
import { SimpleRolePolicy } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { dangerouslyDisableOldPermissions } from '@adornis/users/db/a-user.js';
import { SmartTeamsLMSPolicy } from '@nsc/smartteams-shared/access-control/lms-policy.js';

// App-specific entities and APIs
import './db/SmartTeamsAppUser.js';
import '@nsc/smartteams-shared/db/SmartTeamsCustomer.js';
import './db/ServiceNowTicket.js';
import './db/FEGeolocation.js';
import './db/PudoLocation.js';
import './api/ticket-queries.js';
import './api/colleague-ticket-queries.js';
import './api/ticket-action-queries.js';
import './api/ticket-review-queries.js';
import './api/geolocation-queries.js';
import './api/user-queries.js';
import './api/service-desk-queries.js';
import './db/ServiceDeskRecipients.js';
import './db/TicketReview.js';
import './db/TicketLocationCache.js';
import './features/permissions/roles-and-permissions.js';

dangerouslyDisableOldPermissions();

initLMS({ policies: [SimpleRolePolicy, SmartTeamsLMSPolicy, DefaultLMSPolicy] });
